/**
 * What just happened to two-step verification, handed to `/security` through router state by the
 * screen that caused it. Router state rides on the history entry, so `AccountSecurityView` clears
 * it once read - a reload then shows the page as it is, not the news again.
 */
export type SecurityOutcome = "enabled" | "disabled";

const KEY = "securityOutcome";

export const outcomeState = (outcome: SecurityOutcome) => ({ [KEY]: outcome });

export const readOutcome = (state: unknown): SecurityOutcome | null => {
  const value = (state as Record<string, unknown> | null)?.[KEY];
  return value === "enabled" || value === "disabled" ? value : null;
};
